import { BusyService } from "../../../services/busy-service";
import { WebApiService } from "../../../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

import 'tinymce/themes/modern/theme';


//import 'ag-grid-enterprise/main';
import { observable, computedFrom, autoinject, bindable } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { DialogService } from "aurelia-dialog";
import { PageMessageService } from "../../../services/page-message-service";
import { SecurityService } from "../../../services/security-service";

import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/paste/plugin';
import 'tinymce/plugins/hr/plugin';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/media/plugin';
import 'tinymce/plugins/code/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/themes/modern/theme';
import { Guid } from "guid-typescript";


@singleton()
@autoinject()
export class ComposeEmail {

    public tinyMceOptions: any;

    public fileInput: HTMLInputElement;
    public fileCount: number;
    public totalSize: number;
    public selectedFiles: any[] = [];

    @observable()
    public context: any;
    public contextChanged() {
        this.email.recipients = this.context.recipients
    }

    @observable()
    public selectedTemplateId: string;
    public selectedTemplateIdChanged() {
        const template = this.emailTemplates.find(o => o.id == this.selectedTemplateId);
        if (template) {
            this.email.recipients = this.context.recipients || template.recipients;
            this.email.subject = template.subject;
            this.email.body = template.body;
        }
    }
    public emailTemplates: any[] = [];

    constructor(
        private busyService: BusyService,
        private securityService: SecurityService,
        private dialogService: DialogService,
        private pageMessageService: PageMessageService,
        private api: WebApiService) {

        this.tinyMceOptions = {
            toolbar: "formatselect bold italic | bullist numlist | link unlink | image media | code",
            menubar: false,
            height: "300px",
            plugins: ['link', 'paste', 'code', 'media', 'image', 'lists'],
            branding: false,
            hidden_input: true,
            browser_spellcheck: true
        };

        this.getTemplates();
    }


    attached() {
        (<any>$(".info-button")).popover();
    
        // bind to change event on the file input
        this.fileInput.addEventListener("change", () => this.fileSelectionChanged());
    }

    public fileSelectionChanged(): void {
        this.populateUI(this.fileInput);
    }

    public attachFile() {
        this.fileInput.click();
    }

    private getTemplates() {

        this.busyService.on();
        return this.api.get("Email", "GetNotificationTemplates")
            .then((result) => {
                const templates: any[] = JSON.parse(result.response);
                templates.unshift({ subject: "", body: "", recipients: "" });
                this.emailTemplates = templates.filter(o=>!o.name || o.name.indexOf("sys_") == -1);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    public bodyEditor: any;

    public async send(): Promise<void> {
        // put the selected files in FormData
        const formData = new FormData();
        for (let i = 0; i < this.fileInput.files.length; i++) {
            const element = this.fileInput.files[i];
            formData.append("file", element);
        }

        formData.append('from', this.email.from);
        formData.append('recipients', this.email.recipients);
        formData.append('additionalRecipients', this.email.additionalRecipients);

        formData.append('subject', this.email.subject);
        formData.append('body', this.email.body);

        var textContent = this.bodyEditor.editorInstance.getContent({ format: "text" });
        formData.append('bodyText', textContent);

        formData.append('targetRowId', this.context.targetRowId);
        formData.append('targetTable', this.context.targetTable);

        this.busyService.on();
        try {
            await this.api.post("email", "sendEmail2", formData);
        }
        finally {
            this.busyService.off();
        }
    }


    public returnFileSize(number: number): string {
        // shamelessly borrowed from MDN <img draggable="false" role="img" class="emoji" alt="💖" src="https://s.w.org/images/core/emoji/13.0.0/svg/1f496.svg"><img draggable="false" role="img" class="emoji" alt="🙇‍♂️" src="https://s.w.org/images/core/emoji/13.0.0/svg/1f647-200d-2642-fe0f.svg">
        if (number < 1024) {
            return number + "bytes";
        } else if (number >= 1024 && number < 1048576) {
            return (number / 1024).toFixed(1) + "KB";
        } else if (number >= 1048576) {
            return (number / 1048576).toFixed(1) + "MB";
        }
    }

    private populateUI(fileInput: HTMLInputElement): void {
        for (let i = 0; i < fileInput.files.length; i++) {
            this.fileCount += 1;
            this.totalSize += fileInput.files[i].size;

            this.selectedFiles.push({
                file: fileInput.files[i],
                name: fileInput.files[i].name,
                size: this.returnFileSize(fileInput.files[i].size),
                url: URL.createObjectURL(fileInput.files[i]),
            });
        }
    }

    public clearAttachment(file) {
        var index = this.selectedFiles.findIndex(o => o.file == file.file);
        if (index > -1) {
            this.selectedFiles.splice(index, 1);
        }
    }

    public clearSelection(): void {
        this.fileInput.value = "";
        // clear any previously selected files
        this.fileCount = 0;
        this.totalSize = 0;
        this.selectedFiles = [];
    }

    @bindable()
    public email = {
        from: "Nucor",
        recipients: "",
        additionalRecipients: "",
        subject: "",
        body: "",
    }

}